module.exports = __webpack_public_path__ + "assets/img/sportageous.ebd6dff8.jpg";